import Vue from "vue";
import Vuex from "vuex";

const Cerfa = {
  namespaced: true,
  state: {
    cerfaSelected: {},
    cerfa14023: {
      installationConnection: null,
      isAccessDevelopment: null,
      installationFencesAlignment: null,
      installationFencesBackAlignment: null,
      installationGateAlignment: null,
      installationGateBackAlignment: null,
      installationPlantationAlignment: null,
      installationPlantationBackAlignment: null,
      natureWork: null,
      natureWorkOther: null,
      parkingExtension: null,
      parkingPermit: null,
      parkingNature: null,
      trackWidth: null,
      sidewalkWidth: null,
      protrusionWidth: null,
      heightUnderProtrusion: null,
      ditchCrossing: null,
      pipeDiameter: null,
      pipeLength: null,
      distanceFromRoad: null,
      typePipe: null,
      layoutWidth: null,
      newInstallation: null,
      networkConnection: null,
      longitudinalTrenchUnderRoad: null,
      transverseTrenchUnderRoad: null,
      drivingUnderRoad: null,
      longitudinalTrenchUnderSidewalks: null,
      transverseTrenchUnderSidewalks: null,
      drivingUnderSidewalks: null,
      surfacePlanningEquipment: null,
      parkingNatureOther: null,
      networkConnectionOther: null,
      surfacePlanningEquipmentOther: null,
      themes: null,
      workProjectDeclaration: null,
      teleServiceNumber: null,
      digitalPlanningDeclaration: null,
      ftth: null,
      pipelineDepositLength: null,
      pipelinePoseLength: null,
      pipelineDepositTotalLength: null,
      pipelinePoseTotalLength: null,
      pipelinePoseNumber: null,
      pipelineDepositNumber: null,
      buriedCableDepositLength: null,
      buriedCableDepositNumber: null,
      buriedCablePoseLength: null,
      buriedCablePoseTotalLength: null,
      buriedCableDepositTotalLength: null,
      buriedCablePoseNumber: null,
      airArteryDepositLength: null,
      airArteryPoseLength: null,
      cupboardsNumberDeposit: null,
      cupboardsSurfDeposit: null,
      cupboardsNumberPose: null,
      cupboardsSurfPose: null,
      pavilionBollardNumberDeposit: null,
      pavilionBollardNumberPose: null,
      pavilionBollardSurfPose: null,
      pavilionBollardSurfDeposit: null,
      poleNumberDeposit: null,
      poleNumberPose: null,
      undergroundChamberNumberDeposit: null,
      undergroundChamberNumberPose: null,
      customePipeDiameter: null,
      contactLastName: null,
      contactFirstName: null,
      contactPhone: null,
      contactFax: null,
      contactNumFolder: null,
      contactEmail: null,
      isFavorable: null,
      parapheurDecision: null,
      commentDecision: null,
      //Listes des nouveaux champs vis à vis du formulaire de décision, à ajouter en BDD servira pour conditionner le modèle d'arrêté

      instructeurId: null,
      aerien: null,
      decisionRoadwayTrench: null,
      decisionSidewalkTrench: null,
      decisionShoulderVirginLandTrench: null,
      decisionRoadwayTrenchRecommended: null,
      decisionSidewalkTrenchRecommended: null,
      decisionShoulderVirginLandTrenchRecommended: null,
      decisionSondage: null,
      decisionHorizontalSignage: null,
      decisionFacilitiesInfo: null,
      decisionSinking: null,
      decisionRefections: null,
      decisionTransportNetwork: null,
      decisionRejetEU: null,
      decisionSurfacem2: null,
      decisionDebitLS: null,
      decisionResultCalc: null,

      decisionAccessEdl: null,
      decisionAccessPortailOpen: null,
      decisionAccessStationnement: null,
      decisionAccessRetournement: null,
      decisionAccessRemiseEtatDp: null,
      decisionAccessEauxPluviales: null,
      decisionAccessFosse: null,
      decisionAccessFosseDiametre: null,
      decisionAccessMotifsRefus: null,
    },
    alignement: {
      alignmentOrderNumber: null,
      autorisationUrba: null,
      dateRequest: null,
      groundAlreadyRequested: null,
      id: null,
      dosAutorisationUrba: null,
      typeDossier: null,
      reasonRequest: null,
      reasonRequestOther: null,
      isFavorable: null,
      parapheurDecision: null,
      commentDecision: null,
      instructeurId: null,

      //Listes des nouveaux champs vis à vis du formulaire de décision, à ajouter en BDD
      decisionHorsCompetence: null,
      // --------------------RUES ET POINTS----------------------------
      rue: [],
    },
  },
  actions: {
    initCerfa14023(context) {
      return new Promise((resolve, reject) => {
        let cerfa = {
          installationConnection: null,
          isAccessDevelopment: null,
          installationFencesAlignment: null,
          installationFencesBackAlignment: null,
          installationGateAlignment: null,
          installationGateBackAlignment: null,
          installationPlantationAlignment: null,
          installationPlantationBackAlignment: null,
          natureWork: null,
          natureWorkOther: null,
          parkingExtension: null,
          parkingPermit: null,
          parkingNature: null,
          trackWidth: null,
          sidewalkWidth: null,
          protrusionWidth: null,
          heightUnderProtrusion: null,
          ditchCrossing: null,
          pipeDiameter: null,
          pipeLength: null,
          distanceFromRoad: null,
          typePipe: null,
          layoutWidth: null,
          newInstallation: null,
          networkConnection: null,
          longitudinalTrenchUnderRoad: null,
          transverseTrenchUnderRoad: null,
          drivingUnderRoad: null,
          longitudinalTrenchUnderSidewalks: null,
          transverseTrenchUnderSidewalks: null,
          drivingUnderSidewalks: null,
          surfacePlanningEquipment: null,
          parkingNatureOther: null,
          networkConnectionOther: null,
          surfacePlanningEquipmentOther: null,
          themes: null,
          workProjectDeclaration: null,
          teleServiceNumber: null,
          digitalPlanningDeclaration: null,
          ftth: null,
          pipelineDepositLength: null,
          pipelinePoseLength: null,
          pipelineDepositTotalLength: null,
          pipelinePoseTotalLength: null,
          pipelinePoseNumber: null,
          pipelineDepositNumber: null,
          buriedCableDepositLength: null,
          buriedCableDepositNumber: null,
          buriedCablePoseLength: null,
          buriedCablePoseTotalLength: null,
          buriedCableDepositTotalLength: null,
          buriedCablePoseNumber: null,
          airArteryDepositLength: null,
          airArteryPoseLength: null,
          cupboardsNumberDeposit: null,
          cupboardsSurfDeposit: null,
          cupboardsNumberPose: null,
          cupboardsSurfPose: null,
          pavilionBollardNumberDeposit: null,
          pavilionBollardNumberPose: null,
          pavilionBollardSurfPose: null,
          pavilionBollardSurfDeposit: null,
          poleNumberDeposit: null,
          poleNumberPose: null,
          undergroundChamberNumberDeposit: null,
          undergroundChamberNumberPose: null,
          customePipeDiameter: null,
          contactLastName: null,
          contactFirstName: null,
          contactPhone: null,
          contactFax: null,
          contactNumFolder: null,
          contactEmail: null,
          isFavorable: null,
          instructeurId: null,
          parapheurDecision: null,
          commentDecision: null,

          //Liste des nouveaux champs
          aerien: null,
          decisionRoadwayTrench: null,
          decisionSidewalkTrench: null,
          decisionShoulderVirginLandTrench: null,
          decisionRoadwayTrenchRecommended: null,
          decisionSidewalkTrenchRecommended: null,
          decisionShoulderVirginLandTrenchRecommended: null,
          decisionSondage: null,
          decisionHorizontalSignage: null,
          decisionFacilitiesInfo: null,
          decisionSinking: null,
          decisionRefections: null,
          decisionTransportNetwork: null,
          decisionRejetEU: null,
          decisionSurfacem2: null,
          decisionDebitLS: null,
          decisionResultCalc: null,
          decisionAccessEdl: null,
          decisionAccessPortailOpen: null,
          decisionAccessStationnement: null,
          decisionAccessRetournement: null,
          decisionAccessRemiseEtatDp: null,
          decisionAccessEauxPluviales: null,
          decisionAccessFosse: null,
          decisionAccessFosseDiametre: null,
          decisionAccessMotifsRefus: null,
        };

        context.commit("SETCERFA14023", cerfa);
        resolve();
      });
    },

    setCerfa14023(context, cerfa) {
      return new Promise((resolve, reject) => {
        context.commit("SETCERFA14023", cerfa);
        resolve();
      });
    },
    addCerfa14023(context, cerfa) {
      for (const [key, value] of Object.entries(cerfa)) {
        if (value === "") {
          cerfa[key] = null;
        }
      }
    
      return Vue.axios.post(window.urlapi + "cerfa14023", cerfa)
        .then((response) => {
          if (response.data.success === false) {
            throw new Error(response.data.message || "Erreur API lors de la création du Cerfa");
          }
          return response.data.data; 
        })
        .catch((error) => {
          console.error("Erreur dans addCerfa14023:", error);
          throw error; 
        });
    },

    updateCerfa14023(context, cerfa) {
      for (const [key, value] of Object.entries(cerfa)) {
        if (value === "") {
          cerfa[key] = null;
        }
      }
      return new Promise((resolve, reject) => {
        Vue.axios
          .put(window.urlapi + "cerfa14023/" + cerfa.id, cerfa)
          .then((response) => {
            Vue.prototype.$awn.success(response.data.message.toString());
            resolve(response.data.data);
          });
      });
    },

    getCerfa(context, payload) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(window.urlapi + "cerfa" + payload.type + "/" + payload.id)
          .then((response) => {
            context.commit("GETCERFA", response.data.data);
            resolve();
          });
      });
    },

    initAlignement(context) {
      return new Promise((resolve, reject) => {
        let alignement = {
          alignmentOrderNumber: null,
          autorisationUrba: null,
          dateRequest: null,
          groundAlreadyRequested: null,
          id: null,
          dosAutorisationUrba: null,
          typeDossier: null,
          reasonRequest: null,
          reasonRequestOther: null,
          isFavorable: null,
          instructeurId: null,
          parapheurDecision: null,
          commentDecision: null,
          decisionHorsCompetence: null,
        };

        context.commit("SETALIGNEMENT", alignement);
        resolve();
      });
    },

    setAlignement(context, alignement) {
      return new Promise((resolve, reject) => {
        context.commit("SETALIGNEMENT", alignement);
        resolve();
      });
    },

    addAlignement(context, alignement) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .post(window.urlapi + "individualAlignmentRequest", alignement)
          .then(
            (response) => {
              if (response.data.success == false) {
                resolve(null);
              } else {
                resolve(response.data.data);
              }
            },
            (failure) => {
              resolve(null);
            }
          );
      });
    },

    updateAlignement(context, alignement) {
      for (const [key, value] of Object.entries(alignement)) {
        if (value === "") {
          alignement[key] = null;
        }
      }
      return new Promise((resolve, reject) => {
        Vue.axios
          .put(
            window.urlapi + "individualAlignmentRequest/" + alignement.id,
            alignement
          )
          .then((response) => {
            Vue.prototype.$awn.success(response.data.message.toString());
            resolve(response.data.data);
          });
      });
    },

    getAlignement(context, payload) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(
            window.urlapi +
              "individualAlignmentRequest" +
              payload.type +
              "/" +
              payload.id
          )
          .then((response) => {
            context.commit("GETALIGNEMENT", response.data.data);
            resolve();
          });
      });
    },
  },
  mutations: {
    GETCERFA: (state, cerfa) => {
      state.cerfaSelected = cerfa;
    },
    GETALIGNEMENT: (state, alignement) => {
      state.alignement = alignement;
    },
    SETCERFA14023: (state, cerfa) => {
      state.cerfa14023 = cerfa;
    },
    SETALIGNEMENT: (state, alignement) => {
      state.alignement = alignement;
    },
  },
  getters: {
    cerfaSelected: (state) => {
      return state.cerfaSelected;
    },
    cerfa14023: (state, cerfa) => {
      return state.cerfa14023;
    },
    alignement: (state, alignement) => {
      return state.alignement;
    },
  },
  modules: {},
};

export default Cerfa;